import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="value-expand"
export default class extends Controller {
  static targets = ["collapsed", "expanded", "collapsedIcon", "expandedIcon"]

  connect() {
    this.showCollapsed()
  }

  toggle(event) {
    event.preventDefault()

    if (this.collapsedTarget.classList.contains("hidden")) {
      this.showCollapsed()
    } else {
      this.showExpanded()
    }
  }

  showCollapsed() {
    this.collapsedTarget.classList.remove("hidden")
    this.expandedTarget.classList.add("hidden")
    if (this.hasCollapsedIconTarget) this.collapsedIconTarget.classList.remove("hidden")
    if (this.hasExpandedIconTarget) this.expandedIconTarget.classList.add("hidden")
  }

  showExpanded() {
    this.collapsedTarget.classList.add("hidden")
    this.expandedTarget.classList.remove("hidden")
    if (this.hasCollapsedIconTarget) this.collapsedIconTarget.classList.add("hidden")
    if (this.hasExpandedIconTarget) this.expandedIconTarget.classList.remove("hidden")
  }
}
